<template>
  <button @click="click"
          :disabled="loading"
          :class="{ 'car-disabled': loading }"
          class="car-btn">
    <slot>Submit</slot>
    <spinner v-if="loading" class="car-spinner car-btn-spinner" />
  </button>
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
  name: 'PrimaryBtn',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {
      if (this.loading) return;
      this.$emit('click');
    }
  },
  components: {
    Spinner
  }
}
</script>
